// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2001":"a9558d92","5508":"ebb4537b","7651":"d26288ed"}[chunkId] + ".css";
};